import React, { memo } from 'react';
import { Col, Row } from 'antd';
import { getWithoutSpaces } from 'common/helpers/format.helper';
import { useAppSelector } from 'app/store/store.hooks';
import { IBitecoinRewardModel, TGroupedBitecoinRewardItem } from 'entities/Bitecoin/Bitecoin.models';
import { BitecoinRewardItemCard } from 'entities/Bitecoin/components/BitecoinRewardItemCard';

interface IComponentProps {
  item: TGroupedBitecoinRewardItem;
  bitecoinBalance: number;
  onRewardItemClick(item: IBitecoinRewardModel): void;
  isDisabled?: boolean;
}

const BitecoinRewardCategoriesListItemComponent: React.FC<IComponentProps> = (props) => {
  const {
    item: { category, rewards },
    bitecoinBalance,
    onRewardItemClick,
    isDisabled,
  } = props;
  const { name } = category;
  const { cartModel } = useAppSelector((state) => state.cart);

  return (
    <>
      <div className="menu-card-sign mt-7" id={getWithoutSpaces(name)}>
        {name}
      </div>

      <Row gutter={[24, 24]}>
        {rewards?.map((reward) => {
          const isInCart = cartModel?.items.find((item) => item.rewardId === reward.id);

          return (
            <Col sm={12} lg={8} xs={24} key={reward.id}>
              <BitecoinRewardItemCard
                item={reward}
                bitecoinBalance={bitecoinBalance}
                onRewardItemClick={onRewardItemClick}
                isDisabled={isDisabled}
                isInCart={!!isInCart}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export const BitecoinRewardCategoriesListItem = memo(BitecoinRewardCategoriesListItemComponent);
